import React, { useMemo, useState, useEffect, useCallback } from "react";
import { getSpecificationEditApi, submitFinancialDetailsAPI, submitSpecificationAPI } from "./table-list-api.js";
import edit from "../../../../assets/Vehicles/edit.png";
import DOMPurify from "dompurify";
import { Doughnut } from "react-chartjs-2";
import CommonStaticDropdown from "../../../common/common_static_dropdown.jsx";

import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import { getFinancialEditApi, submitFinancialAPI } from "./table-list-api.js";
import { FinancialHistoryTableList } from "./FinancialHistoryTableList.jsx";
import { calculateKmProgress, calculateMonthProgress } from "../../../common/helper-func.jsx";

// --- Constants ---
const PURCHASE_METHOD_LIST = [
  { label: "Full Payment", value: "Full Payment" },
  { label: "EMI", value: "EMI" },
  { label: "Loan", value: "Loan" },
  { label: "Lease", value: "Lease" },
  { label: "Rent", value: "Rent" },
];

const DOUGHNUT_OPTIONS = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
};

const MAX_VALUE_LIFE = 100;


export const FinancialView = ({ vehicleId, handleClose }) => {
  // eslint-disable-next-line
  const [financialDetail, setFinancialDetail] = useState({});
  const [purchaseReminderList, setPurchaseReminderList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [vehicleType, setVehicleType] = useState("New Vehicle");
  const [purchaseAmount, setPurchaseAmount] = useState("");
  const [purchaseMethod, setPurchaseMethod] = useState();
  const [purchaseDealer, setPurchaseDealer] = useState("");
  const [dealerMobileNumber, setDealerMobileNumber] = useState("");
  const [dealerAddress, setDealerAddress] = useState("");

  const [vendorName, setVendorName] = useState("");
  const [amount, setAmount] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [tenure, setTenure] = useState("");
  const [amountPerMonth, setAmountPerMonth] = useState("");
  const [startDate, setStartDate] = useState();

  const [insecureDate, setInsecureDate] = useState();
  const [insecureOdometer, setInsecureOdometer] = useState("");
  const [estimatedDate, setEstimatedDate] = useState();
  const [outOfServiceDate, setOutOfServiceDate] = useState();
  const [outOfServiceOdometer, setOutOfServiceOdometer] = useState("");

  // life cycle chart
  const [loading, setLoading] = useState(false);
  const [loadingLifeCycle, setLoadingLifeCycle] = useState(false);
  const [chartDetails, setChartDetails] = useState({});

  const [percentageProgress1, setpercentageProgress1] = useState(null);
  const [percentageProgress, setpercentageProgress] = useState(null);

  // --- Handlers ---
  const handlePurchaseMethodSelect = useCallback((item) => {
    setPurchaseMethod(item);
  }, []);

  const getFinancialEdit = useCallback(async () => {
    try {
      const response = await getFinancialEditApi(`financial/edit/${vehicleId}`);
      if (response.data.success === true) {
        setChartDetails(response.data.chart ?? {});
        setpercentageProgress(calculateMonthProgress(response.data.chart.start_date, response.data.chart.due_date, response.data.chart.current_date));
        setpercentageProgress1(calculateKmProgress(response.data.chart.start_km, response.data.chart.due_km, response.data.chart.driven_km));
        setFinancialDetail(response.data.purchase_details ?? {});
        setPurchaseReminderList(response.data.purchase_reminder ?? []);

        if (response.data.life_cycle != null) {
          const lifeCycle = response.data.life_cycle;
          setInsecureDate(lifeCycle.insecure_date != null && lifeCycle.insecure_date !== "" ? new Date(lifeCycle.insecure_date) : null);
          setInsecureOdometer(lifeCycle.insecure_odometer ?? "");
          setEstimatedDate(lifeCycle.estimated_real_date != null && lifeCycle.estimated_real_date !== "" ? new Date(lifeCycle.estimated_real_date) : null);
          setOutOfServiceDate(lifeCycle.out_of_service_date != null && lifeCycle.out_of_service_date !== "" ? new Date(lifeCycle.out_of_service_date) : null);
          setOutOfServiceOdometer(lifeCycle.out_of_service_odometer ?? "");
        }
        if (response.data.purchase_details != null) {
          const purchaseDetail = response.data.purchase_details;
          setVehicleType(purchaseDetail.purchase_type ?? "");
          setPurchaseAmount(purchaseDetail.purchase_amount ?? "");
          setPurchaseMethod({
            value: purchaseDetail.purchase_method ?? "",
            label: purchaseDetail.purchase_method ?? "",
          });
          setPurchaseDealer(purchaseDetail.purchase_dealer ?? "");
          setDealerMobileNumber(purchaseDetail.dealer_mobile_number ?? "");
          setDealerAddress(purchaseDetail.dealer_address ?? "");
          setVendorName(purchaseDetail.vendor_name ?? "");
          setAmount(purchaseDetail.amount ?? "");
          setInterestRate(purchaseDetail.interest_rate ?? "");
          setTenure(purchaseDetail.tenure_month ?? "");
          setAmountPerMonth(purchaseDetail.amount_per_month ?? "");
          setStartDate(purchaseDetail.start_date != null && purchaseDetail.start_date !== "" ? new Date(purchaseDetail.start_date) : null);
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  }, [vehicleId]);

  const submitForm = async (type) => {
    try {
      let preSanitizeData = {};
      if (type === "Life Cycle") {
        preSanitizeData = {
          vehicle_id: vehicleId,
          insecure_date: insecureDate != null && insecureDate !== "" ? insecureDate.toLocaleDateString("en-CA") : "",
          insecure_odometer: insecureOdometer,
          estimated_real_date: estimatedDate != null && estimatedDate !== "" ? estimatedDate.toLocaleDateString("en-CA") : "",
          out_of_service_date: outOfServiceDate != null && outOfServiceDate !== "" ? outOfServiceDate.toLocaleDateString("en-CA") : "",
          out_of_service_odometer: outOfServiceOdometer,
        };
      } else {
        preSanitizeData = {
          vehicle_id: vehicleId,
          purchase_type: vehicleType,
          purchase_amount: purchaseAmount,
          purchase_method: purchaseMethod != null ? purchaseMethod.value : "",
          purchase_dealer: purchaseDealer,
          dealer_mobile_number: dealerMobileNumber,
          dealer_address: dealerAddress,
          amount: amount,
          vendor_name: vendorName,
          interest_rate: interestRate,
          tenure_month: tenure,
          amount_per_month: amountPerMonth,
          start_date: startDate != null && startDate !== "" ? startDate.toLocaleDateString("en-CA") : "",
        };
      }
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      let response = null;
      if (vehicleId !== null) {
        if (type === "Life Cycle") {
          response = await submitFinancialDetailsAPI(vehicleId, sanitizedData);
        } else {
          response = await submitFinancialAPI(sanitizedData);
        }
      }
      if (response.data.success === true) {
        getFinancialEdit();
        setIsEditing(false);
        handleClose(response);
      }
      return response.data;
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await submitForm("");
    } finally {
      setLoading(false);
    }
  };

  const handleLifeCycleSubmit = async () => {
    setLoadingLifeCycle(true);
    try {
      await submitForm("Life Cycle");
      setIsEditing(false);
    } finally {
      setLoadingLifeCycle(false);
    }
  };

  // --- Effects ---
  useEffect(() => {
    getFinancialEdit();
  }, [getFinancialEdit]);

  useEffect(() => {
    const principal = parseFloat(amount);
    const annualInterestRate = parseFloat(interestRate);
    const emi = parseFloat(amountPerMonth);

    if (!isNaN(principal) && principal > 0 && !isNaN(emi) && emi > 0) {
      if (annualInterestRate === 0 || isNaN(annualInterestRate) || interestRate === "" || interestRate === null) {
        const calculatedTenure = Math.ceil(principal / emi);
        setTenure(calculatedTenure.toString());
      } else if (annualInterestRate > 0) {
        const monthlyInterestRate = annualInterestRate / 100 / 12;

        if (emi <= principal * monthlyInterestRate) {
          setTenure("");
          return;
        }

        const numerator = Math.log(emi / (emi - principal * monthlyInterestRate));
        const denominator = Math.log(1 + monthlyInterestRate);
        const calculatedTenure = Math.ceil(numerator / denominator);

        setTenure(calculatedTenure.toString());
      }
    } else {
      setTenure("");
    }
  }, [amount, interestRate, amountPerMonth]);

  // --- Memos ---
  const doughnutData = useMemo(() => ({
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        data: [
          chartDetails?.complete_percent ?? 0,
          MAX_VALUE_LIFE - (chartDetails?.complete_percent ?? 0),
        ],
        backgroundColor: ["#7157C2", "#F9F9F9"],
        cutout: "70%",
      },
    ],
  }), [chartDetails?.complete_percent]);

  return (
    <div>
      <div className="row">
        <div className="col-xl-8 col-12">
          <div className="bg-white rounded-4 p-3">
            <p className="m-0 fw-600 fs-16">Life cycle details</p>
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="col-xl-4 col-12 p-0 mb-3 mb-xl-0">
                <div className="doughnut text-center">
                  <Doughnut className="p-2" data={doughnutData} options={DOUGHNUT_OPTIONS} />
                  {/* Text in Center */}
                  <div className="centerText fs-20 text-center">
                    <span className=" fw-bold">
                      <span style={{ color: "#7157C2" }}>{chartDetails.complete_percent ?? 0} %</span>
                    </span>
                    <span className=" fw-normal"></span>
                    <br /> of Life
                  </div>
                  <p className="m-0 mt-3 fs-13" style={{ color: "#8790A1" }}>
                    {chartDetails.complete_percent ?? 0}% of life is there based on estimated life
                  </p>
                </div>
              </div>
              <div className="col-xl-8 col-12">
                <div className="col-xl-12 p-3 rounded-4" style={{ backgroundColor: "#F9F9F9" }}>
                  <p>Estimated service life in months</p>
                  <p className=" fw-semibold" style={{ color: "#7157C2" }}>
                    {chartDetails.current_date ?? ""}
                  </p>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {/* Progress Bar */}
                      <div
                        style={{
                          flexGrow: 1,
                          backgroundColor: "#FFFFFF",
                          borderRadius: "50px",
                          overflow: "hidden",
                          height: "16px",
                        }}
                      >
                        <div
                          style={{
                            width: `${percentageProgress ?? 0}%`,
                            backgroundColor: "#7157C2",
                            height: "100%",
                            borderRadius: "50px",
                            transition: "width 0.5s ease",
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between my-1">
                      <p className="m-0">{chartDetails.start_date ?? ""}</p>
                      <p className="m-0">{chartDetails.due_date ?? ""}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 p-3 rounded-4 mt-3" style={{ backgroundColor: "#F9F9F9" }}>
                  <p>Estimated service in kilometer</p>
                  <p className=" fw-semibold" style={{ color: "#7157C2" }}>
                    {chartDetails.driven_km ?? ""} km
                  </p>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {/* Progress Bar */}
                      <div
                        style={{
                          flexGrow: 1,
                          backgroundColor: "#FFFFFF",
                          borderRadius: "50px",
                          overflow: "hidden",
                          height: "16px",
                        }}
                      >
                        <div
                          style={{
                            width: `${percentageProgress1 ?? 0}%`,
                            backgroundColor: "#7157C2",
                            height: "100%",
                            borderRadius: "50px",
                            transition: "width 0.5s ease",
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between my-1">
                      <p className="m-0">{chartDetails.start_km ?? ""} km</p>
                      <p className="m-0">{chartDetails.due_km ?? ""} km</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 mb-3 col-12">
          <div className="bg-white p-3 rounded-4">
            <div className="d-flex justify-content-between align-items-center">
              <label className="d-block mb-1">Details</label>
              <button
                className="border-0 px-4 py-2 text-dark-purple rounded-pill"
                style={{ backgroundColor: "#F5E6FF" }}
                onClick={() => {
                  if (isEditing) {
                    handleLifeCycleSubmit();
                  } else {
                    setIsEditing(!isEditing);
                  }
                }}
                disabled={loadingLifeCycle}
              >
                {isEditing ? (
                  loadingLifeCycle ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )
                ) : (
                  <>
                    <img src={edit} alt="edit" /> Edit
                  </>
                )}
              </button>
            </div>
            {isEditing ? (
              <>
                <div className="row mt-2">
                  <div className="col-12 mb-3">
                    <label className="d-block mb-1">Insecure Date</label>

                    <div className="d-flex flex-column">
                      <DatePicker
                        selected={insecureDate}
                        onChange={(date) => setInsecureDate(date)}
                        dateFormat="dd-mm-yyyy"
                        customInput={
                          <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                            {insecureDate ? insecureDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>}
                            <Calendar size={16} />
                          </button>
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="d-block mb-1">Insecure Odometer</label>
                    <input
                      type="text"
                      className="form-control"
                      value={insecureOdometer}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setInsecureOdometer(value);
                      }}
                    />
                  </div>

                  <div className="col-12 mb-3 d-flex flex-column">
                    <label className="d-block mb-1">Estimated resale date</label>
                    <div className="d-flex flex-column">
                      <DatePicker
                        selected={estimatedDate}
                        onChange={(date) => setEstimatedDate(date)}
                        dateFormat="dd-mm-yyyy"
                        customInput={
                          <button style={{ width: "100%", color: "#8790A1" }} className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                            {estimatedDate ? estimatedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>}
                            <Calendar size={16} />
                          </button>
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="d-block mb-1">Out of service date</label>
                    <div className="d-flex flex-column">
                      <DatePicker
                        selected={outOfServiceDate}
                        onChange={(date) => setOutOfServiceDate(date)}
                        dateFormat="dd-mm-yyyy"
                        customInput={
                          <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                            {outOfServiceDate ? outOfServiceDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>}
                            <Calendar size={16} />
                          </button>
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="d-block mb-1">Out of service odometer</label>
                    <input
                      type="text"
                      className="form-control"
                      value={outOfServiceOdometer}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setOutOfServiceOdometer(value);
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="rounded-4 p-3 mb-1 d-flex" style={{}}>
                  <p className="mb-1" style={{ width: "180px", color: "#8790A1" }}>
                    Insecure date
                  </p>
                  <p className="m-0">{insecureDate ? insecureDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>} </p>
                </div>

                <div className="rounded-4 p-3 mb-1  d-flex" style={{}}>
                  <p className="mb-1" style={{ width: "180px", color: "#8790A1" }}>
                    Insecure odometer
                  </p>
                  <p className="m-0">{insecureOdometer} </p>
                </div>

                <div className="rounded-4 p-3 mb-1  d-flex" style={{}}>
                  <p className="mb-1" style={{ width: "180px", color: "#8790A1" }}>
                    Estimated resale date
                  </p>
                  <p className="m-0">{estimatedDate ? estimatedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>} </p>
                </div>

                <div className="rounded-4 p-3 mb-1  d-flex" style={{}}>
                  <p className="mb-1" style={{ width: "180px", color: "#8790A1" }}>
                    Out of service date
                  </p>
                  <p className="m-0">{outOfServiceDate ? outOfServiceDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>} </p>
                </div>

                <div className="rounded-4 p-3 mb-1  d-flex" style={{}}>
                  <p className="mb-1" style={{ width: "190px", color: "#8790A1" }}>
                    Out of service odometer
                  </p>
                  <p className="m-0">{outOfServiceOdometer} </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col">
        <div className="row">
          <div className="col-xl-6 mb-3 mb-xl-0">
            <div className="bg-white p-3 rounded-4">
              <>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <p className="mb-1">Purchase details</p>
                  <button
                    className="border-0 px-4 py-2 text-dark-purple rounded-pill"
                    style={{ backgroundColor: "#F5E6FF" }}
                    onClick={() => {
                      handleSubmit();
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
                <div className="rounded-4 p-2 d-flex justify-content-start align-items-center gap-2" style={{ background: "#F9F9F9" }}>
                  <div>Vehicle purchase type :</div>
                  <div
                    onClick={() => setVehicleType("New Vehicle")}
                    className="ms-1 rounded-3 p-2 d-flex justify-content-start align-items-center"
                    style={{
                      background: vehicleType === "New Vehicle" ? "#F7EDFF" : "#FFFFFF",
                      border: vehicleType === "New Vehicle" ? "1px solid #471070" : "0px",
                    }}
                  >
                    <input
                      type="radio"
                      value="New Vehicle"
                      checked={vehicleType === "New Vehicle"}
                      onChange={(event) => {
                        setVehicleType(event.target.value);
                      }}
                      style={{ accentColor: "#471070" }}
                    />

                    <div className="ps-2">New Vehicle</div>
                  </div>
                  <div
                    onClick={() => setVehicleType("Old Vehicle")}
                    className="ms-1 rounded-3 p-2 d-flex justify-content-start align-items-center"
                    style={{
                      background: vehicleType === "Old Vehicle" ? "#F7EDFF" : "#FFFFFF",
                      border: vehicleType === "Old Vehicle" ? "1px solid #471070" : "0px",
                    }}
                  >
                    <input
                      type="radio"
                      value="Old Vehicle"
                      checked={vehicleType === "Old Vehicle"}
                      onChange={(event) => {
                        setVehicleType(event.target.value);
                      }}
                      style={{ accentColor: "#471070" }}
                    />

                    <div className="ps-2">Old Vehicle</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Purchase amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={purchaseAmount}
                      onChange={(e) => {
                        setPurchaseAmount(e.target.value);
                      }}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Purchase method</label>
                    <CommonStaticDropdown items={PURCHASE_METHOD_LIST} placeholder="Select type" value={purchaseMethod} onSelect={handlePurchaseMethodSelect} enableSearch={false} />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Purchase dealer</label>
                    <input
                      type="text"
                      className="form-control"
                      value={purchaseDealer}
                      onChange={(e) => {
                        setPurchaseDealer(e.target.value);
                      }}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Dealer mobile number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dealerMobileNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setDealerMobileNumber(value);
                      }}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="d-block mb-1">Dealer address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={dealerAddress}
                      onChange={(e) => {
                        setDealerAddress(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
          <div className="col-xl-6 mb-3 mb-xl-0 ">
            <div className="bg-white p-3 rounded-4 h-100">
              <>
                <p className="mb-1">{purchaseMethod?.label ?? ""} details</p>

                <div className="row mt-2">
                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Vendor Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={vendorName}
                      onChange={(e) => {
                        setVendorName(e.target.value);
                      }}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={amount}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAmount(value);
                      }}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Interest Rate (%)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={interestRate}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                          setInterestRate(value);
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Tenure per Month</label>
                    <input type="text" className="form-control" value={tenure} readOnly style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }} />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Amount per Month</label>
                    <input
                      type="text"
                      className="form-control"
                      value={amountPerMonth}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAmountPerMonth(value);
                      }}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="d-block mb-1">Date</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="dd-mm-yyyy"
                      customInput={
                        <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                          {startDate ? startDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd/mm/yyyy</span>}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white w-100 rounded-4 mb-3 mt-2">
        <FinancialHistoryTableList tableList={purchaseReminderList} />
      </div>
    </div>
  );
};
